<template>
  <div class="acc">
    <div class="common_header">
        <van-icon name="arrow-left" class="back_icon" @click="back"/>
        <!-- <span class="lh_title">{{otype == 1 ? '寄售角色': '担保交易'}}</span> -->
        <span class="lh_title">出售角色</span>
    </div>
    <div class="header_bg"></div>

    <div class="box role_box">
        <div class="tit">账号：{{ account }}</div>
        <div class="content">
            <van-image :src="icon" class="icon"/>
            <div class="info">
                <p class="role_name">{{ role_name }}</p>
                <p class="server_name">{{ server_name }}</p>
            </div>
        </div>
    </div>
    <el-form :show-message="showMessage" @submit.native.prevent :model="actionData" ref="puton">
        <div class="box set_box">
            <div class="tit">上架设置</div>
            <div class="content">
                <el-form-item prop="goods_name" :rules="rules.goods_name">
                    <div class="item">
                        <div class="before">商品标题</div>
                        <div class="after goods_name">
                            <el-input placeholder="请输入商品标题" v-model="actionData.goods_name" maxlength="30"
                            show-word-limit/>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item>
                    <div class="item selltype">
                        <div class="before" @click="openConsignmentdes">
                            <span>交易方式</span>
                            <i>?</i>
                        </div>
                        <div class="after">
                            <p :class="{'active': otype == 1}" @click="otype = 1">寄售</p>
                            <p :class="{'active': otype == 2}" @click="otype = 2">担保</p>
                        </div>
                    </div>
                    <!-- <div class="item">
                        <div class="before">上架天数</div>
                        <div class="after exprice_day">
                            <el-input v-model="day" readonly/>
                        </div>
                    </div> -->
                    <!-- <div class="slider">
                        <p>1</p>
                        <van-slider v-model="actionData.exprice_day" :min="1" :max="14" :step="1" active-color="var(--theme)" bar-height="0.3rem" button-size="1rem"/>
                        <p class="max">14</p>
                    </div> -->
                </el-form-item>
                <el-form-item prop="price" :rules="rules.price">
                    <div class="item">
                        <div class="before">售&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价</div>
                        <div class="after price">
                            <el-input
                                :placeholder="otype == 2 ? '100.00≤售价≤500000.00' : (skipSmsVerify ? '20.00≤售价≤500000.00' : '100.00≤售价≤500000.00')"
                                v-model="actionData.price"
                                type="number"
                            />
                            <span>元</span>
                        </div>
                    </div>
                    <p class="fee_tip" v-if="otype == 2">担保交易：100以上按比例收取手续费（最低10元）</p>
                    <p class="fee_tip" v-else-if="skipSmsVerify">20~100 收取10元手续费，100以上收取10%手续费</p>
                </el-form-item>
                <el-form-item>
                    <div class="item service_fee">
                        <div class="before" @click="openServicefeedes">
                            <span>服&nbsp;&nbsp;务&nbsp;&nbsp;费</span>
                            <i>?</i>
                        </div>
                        <div class="after price">
                            <el-input placeholder="0.00"  v-model="margin" type="number" readonly/>
                            <span>元</span>
                        </div>
                    </div>
                </el-form-item>
                <!-- <div class="item margin">
                    <div class="line1">
                       <p>保证金<van-icon name="question-o" color="var(--theme)" @click="showAbout"/></p>
                       <a href="javascript:;" @click="gotoRecharge">去充值</a>
                    </div>
                    <div class="line2">
                        <div class="left">
                            <p>预计需缴纳</p>
                            <p v-if="actionData.price != '' && Number(actionData.price)>=100 && Number(actionData.price)<=500000">{{actionData.margin}}元</p>
                            <p v-else>—</p>
                        </div>
                        <div class="right">

                            <p>我的保证金</p>
                            <p v-if="userData.margin">{{userData.margin}}元</p>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
        <div class="box contact">
            <div class="tit">角色资产截图</div>
            <div class="content">
                <p class="cut_tit">截图期间将会对您的账号进行封禁操作，为避免影响您的游戏体验，请选择截图方式：</p>
                <el-form-item>
                    <div class="item cut_type">
                        <p :class="{'active': picture_type == 1}" @click="picture_type = 1">官方托管截图</p>
                        <p :class="{'active': picture_type == 2}" @click="picture_type = 2">自行预约截图</p>
                    </div>
                </el-form-item>
                <div class="cut_tip" v-if="picture_type == 1">
                    <i>!</i>
                    <p >工作时间内操作人员将随时对您的账号进行封禁</p>
                </div>
                <div class="cut_tip" v-else-if="picture_type == 2">
                    <i>!</i>
                    <p>发布后请联系客服预约时间，在您方便时进行封号</p>
                </div>
                <div class="contact_tip">
                    为了方便平台联系您，请留下您的有效联系方式
                </div>
                <el-form-item>
                    <div class="item">
                        <div class="before">手机号码</div>
                        <div class="after phone">
                            <el-input placeholder="请输入手机号码" type="tel" :value="userData.username | plusX" readonly/>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="qq" :rules="rules.qq">
                    <div class="item">
                        <div class="before">Q&nbsp;Q号码</div>
                        <div class="after phone">
                            <el-input placeholder="请输入QQ号码" type="number" v-model="actionData.qq" maxlength="13" @input="onInput2"/>
                        </div>
                    </div>
                </el-form-item>
            </div>
        </div>
    </el-form>
    <div class="box role_info">
        <div class="tit">角色信息</div>
        <div class="content">
            <div class="tips">
                *交易平台角色信息存在延迟。若与游戏内不一致，上架后可联系客服修改。
            </div>
            <div v-for="(item,index) in roleinfo_list" :key="index" class="item">
                <div class="before">{{item.name}}</div>
                <div class="after">
                    {{ item.value }}
                </div>
            </div>
            <!-- <div class="item">
                <div class="before">等&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;级：</div>
                <div class="after">
                    <el-input v-model="lv"/>
                </div>
            </div>
            <div class="item">
                <div class="before">性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别：</div>
                <div class="after sex">
                    <p :class="{'active': sex == 1}" @click="sex = 1">男</p>
                    <p :class="{'active': sex == 2}" @click="sex = 2">女</p>
                </div>
            </div>
            <div class="item">
                <div class="before">职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;业：</div>
                <div class="after">
                    <el-input v-model="career"/>
                </div>
            </div>
            <div class="item">
                <div class="before">战&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;力：</div>
                <div class="after">
                    <el-input v-model="power" type="number"/>
                </div>
            </div>
            <div class="item">
                <div class="before">平&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;台：</div>
                <div class="after sys">
                    <p :class="{'active': system_type == 1}" @click="system_type = 1">安卓</p>
                    <p :class="{'active': system_type == 2}" @click="system_type = 2">ios</p>
                    <p :class="{'active': system_type == 3}" @click="system_type = 3">安卓/ios互通</p>
                </div>
            </div> -->
        </div>
    </div>
    <div class="box desc">
        <div class="tit">商品描述（选填）</div>
        <div class="content">
            <el-input class="desc_text" type="textarea" placeholder="请简要描述您的商品~" maxlength="500" show-word-limit v-model="desc"/>
            <!-- <div class="f_tit">
                游戏截图<span>（最多8张）</span>
            </div>
            <div class="upload_area">
                <van-uploader 
                    v-model="list" 
                    multiple 
                    :max-count="8" 
                    :accept="'image/*'"
                    :after-read="afterRead"
                    upload-icon="plus"
                    @delete="deleteUpload"
                />
            </div> -->
        </div>
    </div>
    <div class="check">
        <el-checkbox v-model="agree">
            我已知晓并同意
        </el-checkbox>
        <span @click="openAgree">《交易出售协议》</span>
    </div>
    <van-button class="publish_btn" round :disabled="!(actionData.goods_name != '' && actionData.price != '' && actionData.qq != '' && agree)" :loading="loading" @click="publish">发布</van-button>

    <!-- 发布前安全验证 -->
    <van-popup v-model="showpublish" class="publish_pop">
        <div class="head">
            安全验证 <van-icon name="cross" class="close" @click="showpublish = false"/>
        </div>
        <div class="cont">
            <p class="tit">寄售角色</p>
            <div class="role_info">
                <van-image :src="icon" class="icon"/>
                <div class="info">
                    <p>{{ role_name }}</p>
                    <p>{{ server_name }}</p>
                    <p v-if="otype == 1"><i class="red">寄售</i>商品<i class="red">售卖期间</i>角色将会处于<i class="red">封禁</i>状态</p>
                </div>
            </div>
            <div class="final_price">
                售价：<span>&yen;&nbsp;</span><i>{{ actionData.price }}</i>
            </div>
                <div class="p_tit" v-if="skipSmsVerify">
                    注意检查和确认角色信息是否有误，如误操作上架，请及时下架处理
                </div>
                <template v-else>
                    <div class="p_tit">
                        点击<span>获取验证码</span>，短信将发送至您的绑定手机<br />
                        <span>{{ userData.username | plusX}}</span>
                    </div>
                    <div class="code_area">
                        <van-field :class="{'active': active}" type="number" maxlength="6" v-model="code" ref="code" placeholder="输入手机验证码" @focus="active = true" @blur="active = false"/>
                        <van-button :disabled="code_disabled" @click="sendCode">{{ buttonName }}</van-button>
                    </div>
                </template>
                <van-button class="confirm_publish" :disabled="!canConfirmPublish" color="var(--theme)" round @click="confirm_publish" :loading="publish_loading">确认发布
            </van-button>
        </div>
    </van-popup>
  </div>
</template>

<script>
import {httpRequest} from '@/ajax'
export default {
  data () {
    return {
        buttonName: '获取验证码',
        time: 58,
        active: false,
        code_disabled: false,
        showpublish: false,//发布前安全验证弹框
        otype: 1,//交易方式 1寄售 2担保
        day: '7天',//上架天数 readonly
        uploadimgs: [],//上传图片
        list: [],//上传图片
        agree: true,//同意协议
        loading: false,//发布按钮loading
        showMessage:true,
        //上架参数
        picture_type: null,//截图类型 1官方托管截图 2自行预约截图
        actionData: {
            goods_name: '',//商品名称
            // exprice_day: 7,//上架天数
            price: '',//价格
            // phone: '',//手机号
            qq: '',//QQ号
        },
        margin: '',
        code: '',//验证码
        // ---以下选填---
        lv: '',//等级
        sex: '',//性别
        career: '',//职业
        power: '',//战力
        system_type: 3,//平台
        desc: '',//商品描述
        publish_loading: false,
        icon: '',//游戏图标
        roleinfo_list: [],
        rate: 0,//手续费率
    }
  },
  computed: {
    putonData() {
        const raw = this.$store.state.puton
        if (!raw) return {}
        if (typeof raw === 'string') {
            try {
                return JSON.parse(raw) || {}
            } catch (e) {
                return {}
            }
        }
        return raw
    },
    rules() {
        const { mobile, goods_name, qq } = this.$store.getters.rules;
        return {
            phone: mobile,
            goods_name,
            price: [{
                required: true,
                message: '请输入售价',
                trigger: 'blur'
            }, {
                validator: (rule, value, callback) => {
                    const raw = (value || '').toString().trim()
                    if (!raw) {
                        callback(new Error('请输入售价'))
                        return
                    }
                    if (!/^\d+(\.\d{1,2})?$/.test(raw)) {
                        callback(new Error('售价最多保留两位小数'))
                        return
                    }
                    const amount = Number(raw)
                    const minPrice = this.otype == 2 ? 100 : (this.skipSmsVerify ? 20 : 100)
                    if (amount < minPrice || amount > 500000) {
                        callback(new Error(`售价需在${minPrice}到500000之间`))
                        return
                    }
                    callback()
                },
                trigger: 'blur'
            }],
            qq
        };
    },
    userData() {
        return this.$store.getters.state.userData || {};
    },
    app_id() {
        return this.$route.query.app_id || this.putonData.app_id || ''
    },
    account_id() {
        return this.$route.query.account_id || this.putonData.account_id || ''
    },
    role_id() {
        return this.$route.query.role_id || this.putonData.role_id || ''
    },
    server_id() {
        return this.$route.query.server_id || this.putonData.server_id || ''
    },
    role_name() {
        return this.$route.query.role_name || this.putonData.role_name || ''
    },
    server_name() {
        return this.$route.query.server_name || this.putonData.server_name || ''
    },
    account() {
        return this.$route.query.account || this.putonData.account || ''
    },
    child_user_id() {
        return this.$route.query.child_user_id || this.putonData.child_user_id || ''
    },
    skipSmsVerify() {
        const hasPartnerAccount = this.userData.has_partner_account
        return (this.otype == 1 || this.otype == 2) && (hasPartnerAccount === true || hasPartnerAccount === 1 || hasPartnerAccount === '1')
    },
    canConfirmPublish() {
        if (this.publish_loading) return false
        if (this.skipSmsVerify) return true
        return !!this.actionData && this.code.length == 6
    }
},
  filters: {
    plusX(str) {
        var x = "****";
        if(str) {
            if (str.length >= 6) {
                return  str.substring(0, 3) + x + str.substring(str.length - 4, str.length)
            } else {
                return str;
            }
        }
    },
  },
  created () {
    
  },
  mounted () {
    var that = this
    setTimeout(() => {
        that.$store.dispatch("getUserData",true)
    },500)
    this.getAttr()
  },
  methods: {
    //获取角色信息
    getAttr() {
        this.$Ajax('sdk/role/get-attr',{
            app_id: this.app_id,
            role_id: this.role_id,
            server_id: this.server_id,
        }).then(rs => {
            if(rs.code == 200) {
                this.roleinfo_list = rs.data
            }else {
                this.roleinfo_list = []
            }
        })
    },
    back() {
        if(this.$route.name == 'acc.puton'&&this.$route.query.from != 'order') {
          this.$RModal.accleave({
            noheader:true,
            onSuccess: () => {
                this.$router.go(-1)
            //   this.$router.push({
            //     name: 'user.goods',
            //     params: {
            //         status: 0
            //     }
            //   })
            }
          })
        }else {
          this.$router.go(-1)
        } 
    },
    getAppIcon() {
        this.$Ajax('game/app-list').then(rs => {
            if(rs.code == 200) {
                var item = rs.data.find(item => item.id == this.app_id)
                this.icon = item.icon
                this.rate = item.role_rate || 0
            }
        })
    },
    onInput(val) {
        this.actionData.phone = val.replace(/\D/g, '');
    },
    onInput2(val) {
        this.actionData.qq = val.replace(/\D/g, '');
    },
    //上传图片
    afterRead(file) {
        file.status = 'uploading';
        file.message = '上传中...';
        if(file.length) {
            for(var i = 0; i < file.length; i++) {
                httpRequest('wallet/upload-img',file[i].file).then(rs=> {
                    if(rs.data.code == 200) {
                        this.uploadimgs.push({url: rs.data.data.path})
                        this.list = this.uploadimgs
                        file.status = 'done'
                    }else {
                        file.status = 'failed'
                    }
                })
            }
        }else {
            httpRequest('wallet/upload-img',file.file).then(rs => {
                if(rs.data.code == 200) {
                    this.uploadimgs.push({url: rs.data.data.path})
                    this.list = this.uploadimgs
                    file.status = 'done'
                }else {
                    file.status = 'failed'
                }
            })
        }
    },
    deleteUpload(file,detail) {
        this.uploadimgs.splice(detail.index,1)
    },
    //agree
    openAgree() {
        var that = this
        this.$filterPop({
            type: 'agree',
            direction: 'fade',
            onSuccess: () => {
                that.agree = true
            }
        })
    },
    //发布按钮 表单验证
    publish() {
        if(!this.picture_type) {
            this.$toast('请选择截图类型')
            return
        }
        var that = this
        this.$refs.puton.validate(valid => {
            this.showMessage = true;
            if(valid) {
                this.showpublish = true
            }else {
                this.$toast('填写错误，请检查')
            }
        })
    },
    //发送验证码
    sendCode() {
        var that = this
        this.code_disabled = true
        this.$Ajax('login-out/send-msg',{otype: 2},'get').then(rs => {
            if(rs.code == 200) {
                this.buttonName = '已发送(59s)'
                let interval = window.setInterval(function () {
                    that.buttonName = '已发送('+ that.time +'s)'
                    that.time--;
                    if (that.time < 0) {
                      that.buttonName = "重新发送";
                      that.time = 58;
                      that.code_disabled = false;
                      window.clearInterval(interval);
                    }
                },1000)
                setTimeout(() => {
                    that.$refs.code.focus()
                }, 50);   
            }else {
                that.buttonName = "重新发送";
                that.time = 58;
                that.code_disabled = false;
            }
        })
    },
    //确定发布
    confirm_publish() {
        var that = this
        this.publish_loading = true
        var params = {
            app_id: this.app_id,
            account_id: this.account_id,
            server_id: this.server_id,
            server_name: this.server_name,
            role_id: this.role_id,
            role_name: this.role_name,
            otype: this.otype,
            ...this.actionData,
            picture_type: this.picture_type,
            role_attr: this.roleinfo_list.length != 0 ? this.roleinfo_list : ''
        }
        if(this.child_user_id) {
            params.child_user_id = this.child_user_id
        }
        if(this.desc.trim() != '') params.desc = this.desc
        // if(this.system_type != '') params.system_type = this.system_type
        // if(this.lv != '') params.lv = this.lv
        // if(this.sex != '') params.sex = this.sex
        // if(this.career != '') params.career = this.career
        // if(this.power != '') params.power = this.power
       
        // if(this.uploadimgs.length != 0) params.goods_pic = this.uploadimgs.map(item => item.url)
        if (this.skipSmsVerify) {
            this.submitPublish(params).finally(() => {
                setTimeout(() => {
                    that.publish_loading = false
                },2000)
            })
            return
        }
        this.$Ajax('login-out/send-msg',{otype: 2,code: this.code},'get').then(res => {
            if(res.code == 200) {
                return this.submitPublish(params)
            }
        }).finally(() => {
            setTimeout(() => {
                that.publish_loading = false
            },2000)
        })
    },
    submitPublish(params) {
        return this.$Ajax('v2/goods/role',params).then(rs => {
            if(rs.code == 200) {
                this.$router.push({
                    name: 'order.detail',
                    query: {
                        id: rs.data.goods_id,
                        from: 'puton'
                    }
                })
            }
            // else if(rs.code == 888) {
            //     this.showpublish = false
            //     this.nomargin()
            // }
        })
    },

    // ---- 保证金 start-----
    // 保证金说明
    showAbout() {
        this.$RModal.aboutmargin({noheader:true})
    },
    //保证金不足
    nomargin() {
        this.$RModal.nomargin({
            noheader:true,
            onSuccess: () => {
                //前往充值
                this.gotoRecharge()
            }
        }) 
    },
    //前往充值
    gotoRecharge() {
        this.$RModal.margin({
            noheader:true,
            selection: {
                wide: true,
            }
        })
    },
    // ---- 保证金 end ------

    // 交易方式说明
    openConsignmentdes() {
        this.$RModal.consignmentdes({
            noheader:true,
            selection: {
                otype: this.otype
            }
        })
    },
    // 服务费说明
    openServicefeedes() {
        this.$RModal.servicefeedes({
            noheader:true,
                selection: {
                    rate: this.rate,
                    is_partner_consignment: this.skipSmsVerify
                }
        })
    },
        },
        watch: {
    // userData: {
    //     immediate: true,
    //     deep: true,
    //     handler(val) {
    //         if (val && val.username) {
    //             this.actionData.phone = val.username;
    //         }
    //     }
    // },
    // 'actionData.exprice_day'(e) {
    //     this.day = e + '天'
    // },
        'actionData.price'(e) {
            const amount = Number(e)
            if (this.otype == 2) {
                if (amount >= 100 && amount <= 500000) {
                    const fee = (amount / 100) * this.rate
                    this.margin = fee < 10 ? '10.00' : fee.toFixed(2)
                } else {
                    this.margin = ''
                }
                return
            }
            if (this.skipSmsVerify) {
                if(amount >= 20 && amount <= 100) {
                    this.margin = '10.00'
                }else if(amount > 100 && amount <= 500000) {
                    this.margin = (amount * 0.1).toFixed(2)
                }else {
                    this.margin = ''
                }
                return
            }
            if(amount >= 100 && amount <= 500000) {
                const fee = (amount / 100) * this.rate
                this.margin = fee < 10 ? '10.00' : fee.toFixed(3)
            }else {
            this.margin = ''
        }
    },
    app_id: {
        immediate:true,
        handler(e) {
            if(e) {
                this.getAppIcon()
            }
        }
    }
  },
}
</script>

<style lang="less" scoped>
.acc {
    padding: 6rem 1rem 5rem;
}
.box {
    border-radius: 1rem;
    margin-bottom: .8rem;
    background-color: #fff;
    overflow: hidden;
    .tit {
        background: var(--theme);
        color: #fff;
        padding: 1rem;
        font-size: 1.6rem;
        font-weight: 700;
    }
    .content {
        padding: 1.5rem 1rem 1rem;
        .el-form-item {
            margin-bottom: 1.8rem;
            /deep/.el-form-item__error {
                right: 0;
                text-align: end;
                margin-top: 0;
                font-size: 1.2rem;
            }
        }
    }
}
.role_box {
    .content {
        padding: 1.2rem;
        display: flex;
        align-items: flex-start;
        .icon {
            width: 6rem;
            height: 6rem;
            border-radius: 1.2rem;
            overflow: hidden;
            margin-right: 1rem;
        }
        .info {
            flex: 1;
            overflow: hidden;
            word-break: break-all;
            padding-top: .6rem;
            .role_name {
                font-size: 1.8rem;
                margin-bottom: .4rem;
            }
            .server_name {
                font-size: 1.4rem;
                color: #555;
            }
        }
    }
}
.set_box,
.contact {
    .fee_tip {
        margin-top: .6rem;
        font-size: 1.2rem;
        color: #999;
        text-align: end;
    }
    .item {
        margin: 0;
        padding: 0;
        display: flex;
        align-items: center;
        .before {
            width: 6.6rem;
            margin-right: 1.5rem;
            font-size: 1.6rem;
            color: #000;
        }
        .after {
            flex: 1;
        }
        .goods_name {
            /deep/.el-input {
                
                .el-input__inner {
                    border: none;
                    height: 4rem;
                    line-height: 4rem;
                    background-color: #f5f5f5;
                    border-radius: 1rem;
                    padding: 0;
                    padding: 0 5rem 0 1.6rem;
                    font-size: 1.4rem;
                }
                .el-input__suffix {
                    .el-input__suffix-inner {
                        .el-input__count {
                            .el-input__count-inner {
                                text-align: end;
                                width: 4rem;
                                font-size: 1.4rem;
                                color: #999;
                                margin: 0;
                                background-color: transparent;
                            }
                        }
                    }
                   
                }
            }
        }
        .exprice_day,
        .phone {
            /deep/.el-input {
                .el-input__inner {
                    border: none;
                    height: 4rem;
                    line-height: 4rem;
                    background-color: #f5f5f5;
                    border-radius: 1rem;
                    padding: 0;
                    padding: 0 1.6rem;
                    font-size: 1.4rem;
                }
            }
        }
        .price {
            display: flex;
            align-items: center;
            /deep/.el-input {
                .el-input__inner {
                    border: none;
                    height: 4rem;
                    line-height: 4rem;
                    background-color: #f5f5f5;
                    border-radius: 1rem;
                    padding: 0;
                    padding: 0 1.6rem;
                    font-size: 1.4rem;
                }
            }
            span {
                font-size: 1.6rem;
                color: #000;
                margin-left: 1rem;
            }
        }

        &.selltype,
        &.service_fee {
            .before {
                width: 8.8rem;
                display: flex;
                align-items: center;
                margin-right: .8rem;
                i {
                    width: 1.4rem;
                    height: 1.4rem;
                    line-height: 1.4rem;
                    text-align: center;
                    display: inline-block;
                    border-radius: 50%;
                    border: 1px solid #EF4D3D;
                    color: #EF4D3D;
                    font-size: 1rem;
                    margin-left: .4rem;
                    cursor: pointer;
                }
            }
            .after {
                display: flex;
                align-items: center;
                p {
                    width: 50%;
                    height: 4rem;
                    line-height: 4rem;
                    text-align: center;
                    border-radius: 1rem;
                    cursor: pointer;
                    background-color: #f5f5f5;
                    font-size: 1.4rem;
                    color: #555;
                    &:not(:last-child) {
                        margin-right: 1.4rem;
                    }
                    &.active {
                        background-color: #FFEFE4;
                        color: #F66F30;
                    }
                }
            }
        }
        &.service_fee {
            .after {
                &.price {
                    /deep/.el-input {
                        .el-input__inner {
                           background-color: transparent;
                           padding: 0;
                        }
                    }
                }
            }
        }
        &.cut_type {
            display: flex;
            align-items: center;
            p {
                width: 50%;
                height: 4rem;
                line-height: 4rem;
                text-align: center;
                border-radius: 1rem;
                cursor: pointer;
                background-color: #f5f5f5;
                font-size: 1.4rem;
                color: #555;
                font-weight: 700;
                border: 1px solid #f5f5f5;
                &:not(:last-child) {
                    margin-right: 1.5rem;
                }
                &.active {
                    background-color: #FFEFE4;
                    color: #F66F30;
                    border-color: #f66f30;
                }
            }
        }
    }
    .cut_tit {
        font-size: 1.2rem;
        color: #606060;
        margin-bottom: 1rem;
        i {
            color: var(--theme);
        }
    }
    .cut_tip {
        margin-bottom: 1.5rem;
        color: #606060;
        font-size: 1.2rem;
        i {
            width: 1.4rem;
            height: 1.4rem;
            line-height: 1.4rem;
            text-align: center;
            display: inline-block;
            border-radius: 50%;
            border: 1px solid #EF4D3D;
            color: #EF4D3D;
            font-size: 1rem;
            margin-right: 0.4rem;
        }
        p {
            display: inline-block;
        }
    }
    .contact_tip {
        margin-bottom: 1.5rem;
        color: #606060;
        font-size: 1.2rem;
    }
    .slider {
        display: flex;
        justify-content: space-between;
        align-items: center;
        p {
            width: 2.6rem;
            font-size: 1.6rem;
        }
        .max {
            text-align: end;
        }
        .van-slider {
            flex: 1;
        }
        /deep/.van-slider__button {
            background-color: var(--theme);
            cursor: pointer;
            box-shadow: none;
            animation: btnscale 1s ease-in-out 2 forwards;
        }
    }
    .margin {
        margin-top: 3rem;
        display: block;
        .line1 {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1.4rem;
            p {
                display: flex;
                align-items: center;
                font-size: 1.6rem;
                color: #000;
                .van-icon {
                    font-size: 1.4rem;
                    margin-left: 0.5rem;
                    margin-top: 0.2rem;
                    font-weight: 700;
                    cursor: pointer;
                }
            }
            a {
                color: var(--theme);
                font-size: 1.6rem;
                text-decoration: underline;
            }
        }
        .line2 {
            display: flex;
            height: 8.5rem;
            background-color: #f5f5f5;
            border-radius: 1rem;
            .left, .right {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                position: relative;
                font-size: 1.4rem;
                p:nth-child(1) {
                    margin-bottom: .6rem;
                }
                p:nth-child(2) {
                    font-weight: 700;
                }
                &::after {
                    content: '';
                    position: absolute;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 1px;
                    height: 1.8rem;
                    background-color: #000;
                }
            }
            .right {
                &::after {
                    display: none;
                }
            }
        }
    }
    
}
.contact {
    .el-form-item {
        margin-bottom: 2rem;
    }
}
.role_info {
    .tips {
        font-size: 1.2rem;
        color: #606060;
        margin-top: -.5rem;
        margin-bottom: 1.4rem;
    }
    .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 1.5rem;
        font-size: 1.6rem;
        margin-bottom: 1.5rem;
        &:last-child {
            margin-bottom: 0;
        }
        .sex {
            display: flex;
            align-items: center;
            p {
                width: 5rem;
                height: 2.2rem;
                line-height: 2.2rem;
                text-align: center;
                border-radius: 10rem;
                background-color: #f5f5f5;
                color: #555;
                font-size: 1.4rem;
                margin-right: .7rem;
                cursor: pointer;
                &.active {
                    background-color: var(--themebgc);
                    color: var(--theme);
                }
            }
        }
        .sys {
            display: flex;
            align-items: center;
            p {
                width: 12.8rem;
                height: 3.4rem;
                line-height: 3.4rem;
                text-align: center;
                height: 3.4rem;
                line-height: 3.4rem;
                text-align: center;
                background-color: #f5f5f5;
                color: #555;
                font-size: 1.4rem;
                margin-right: .8rem;
                border-radius: 10rem;
                cursor: pointer;
                &.active {
                    background-color: var(--themebgc);
                    color: var(--theme);
                }
            }
            p:nth-child(1),
            p:nth-child(2) {
                width: 6.2rem;
            }
        }
    }
}
.desc {
    margin-bottom: 1.5rem;
    .content {
        padding-bottom: 0;
    }
    .desc_text {
        height: 12rem;
        background-color: #f5f5f5;
        border-radius: 1rem;
        padding: 1.2rem 1.4rem;
        margin-bottom: 1.2rem;
        display: flex;
        flex-direction: column;
        /deep/.el-textarea__inner {
            flex: 1;
            padding: 0;
            background-color: transparent;
            border: none;
            font-size: 1.4rem;
        }
        /deep/.el-input__count {
            margin-top: 0.5rem;
            height: 1.4rem;
            font-size: 1.4rem;
            color: #999;
            background-color: transparent;
            position: initial;
            text-align: end;
        }
    }
}
.f_tit {
    font-size: 1.6rem;
    color: #000;
    margin-bottom: 1.2rem;
    span {
        color: #999;
    }
}
.upload_area {
    /deep/.van-uploader__upload-icon {
        font-size: 2.6rem;
        font-weight: 700;
        color: #999;
    }
    /deep/.van-uploader__upload,
    /deep/.van-uploader__preview-image {
        width: 6.9rem;
        height: 6.9rem;
        border-radius: 1rem;
    }
    /deep/.van-uploader__preview,
    /deep/.van-uploader__upload {
       margin: 0 1.4rem 1.4rem 0;
       border-radius: 1rem;
       &:nth-child(4n) {
            margin: 0;
       }
    }
    /deep/.van-uploader__mask {
        border-radius: 1rem;
    }
    /deep/.van-uploader__preview-delete {
        width: 1.6rem;
        height: 1.6rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #ffd6d6;
        border-radius: 50%;
        top: -0.6rem;
        right: -0.6rem;
        .van-uploader__preview-delete-icon {
            font-size: 1rem;
            color: var(--theme);
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
        }
    }
}
.check {
    display: flex;
    align-items: center;
    /deep/.el-checkbox__inner {
        width: 1.5rem !important;
        height: 1.5rem !important;
        &::after {
            height: 0.75rem !important;
            left: 0.35rem !important;
            top: 0 !important;
        }
    }
    /deep/.el-checkbox {
        width: unset !important;
        .el-checkbox__input {
            display: flex;
            align-items: center;
        }
        .el-checkbox__label {
            margin-top: 0.25rem;
            width: auto;
            font-size: 1.2rem;
            color: #aaa;
            transform: scale(1);
        }
    }
    span {
        font-size: 1.2rem;
        color: var(--theme);
        cursor: pointer;
    }
}
.publish_btn {
    width: 100%;
    height: 4rem;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    background-color: var(--theme);
    margin: 1.8rem 0 3rem;
    font-size: 1.6rem;
    &:disabled {
        background-color: #999;
        opacity: 1;
    }
}

.publish_pop {
    width: 29.2rem;
    border-radius: 1.5rem;
    overflow: hidden;
    .head {
        height: 3.6rem;
        line-height: 3.6rem;
        text-align: center;
        color: #fff;
        font-size: 1.6rem;
        font-weight: 700;
        background: var(--theme);
        position: relative;
        .close {
            font-size: 1.8rem;
            color: #fff;
            font-weight: 700;
            position: absolute;
            right: .8rem;
            top: 50%;
            transform: translateY(-50%);
            cursor: pointer;
        }
    }
    .cont {
        padding: 1.6rem;
        .tit {
            font-size: 1.6rem;
            padding-left: .6rem;
            margin-bottom: 1rem;
            position: relative;
            &::before {
                content: "";
                position: absolute;
                left: 0;
                top: 55%;
                transform: translateY(-50%);
                width: .2rem;
                height: 1.4rem;
                background-color: #ef4d3d;
            }
        }
        .role_info {
            display: flex;
            align-items: flex-start;
            .icon {
                width: 5.8rem;
                height: 5.8rem;
                border-radius: 1.2rem;
                overflow: hidden;
                margin-right: .6rem;
            }
            .info {
                flex: 1;
                overflow: hidden;
                p:nth-child(1) {
                    color: #000;
                    font-size: 1.5rem;
                    margin-bottom: .4rem;
                }
                p:nth-child(2) {
                    color: #555;
                    font-size: 1rem;
                    word-break: break-all;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                }
                p:nth-child(3) {
                    color: #555;
                    font-size: 1.1rem;
                    margin-top: .4rem;
                    white-space: nowrap;
                    .red {
                        color: #ef4d3d;
                    }
                }
            }
        }
        .final_price {
            text-align: end;
            font-size: 1.2rem;
            color: #000;
            padding-bottom: 1rem;
            border-bottom: 1px solid #f2f2f2;
            i {
                color: #ef4d3d;
                font-size: 1.6rem;
                font-style: normal;
                font-weight: 700;
            }
        }
        .p_tit {
            padding-top: 1.2rem;
            font-size: 1.25rem;
            line-height: 1.5;
            margin-bottom: 1rem;
            span {
                color: #ef4d3d;
            }
        }
        .code_area {
            display: flex;
            .van-field {
                padding: 0 1rem;
                flex: 1;
                height: 4rem;
                line-height: 4rem;
                background-color: #f5f5f5;
                font-size: 1.3rem;
                border-radius: 1rem;
                color: #000;
                /deep/.van-field__control {
                    background-color: transparent;
                }
                &.active {
                    background-color: #ffebeb;
                }
            }
            .van-button {
                margin-left: .8rem;
                padding: 0;
                width: 10.6rem;
                height: 4rem;
                border-radius: 1rem;
                background-color: var(--themebgc);
                color: var(--theme);
                font-size: 1.3rem;
                border: none;
                &:disabled {
                    opacity: 1;
                    color: #555;
                    background-color: #f5f5f5;
                }
            }
        }
        .confirm_publish {
            margin-top: 1.2rem;
            width: 100%;
            height: 3.2rem;
            font-size: 1.6rem;
            border: none;
            &:disabled {
                background-color: #999 !important;
            }
        }
    }
}
@keyframes btnscale {
    0% {
        width: 1.5rem;
        height: 1.5rem;
    }
    100% {
        width: 1rem;
        height: 1rem;
    }
}
.common_header {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    width: 100%;
    max-width: 525px;
    height: 5rem;
    line-height: 5rem;
    background: url(../../assets/version_1.3.0/index/linear.png) no-repeat 0 -3.7rem / 100% 26.2rem;
    background-color: #fff;
    text-align: center;
    font-size: 1.6rem;
    .back_icon,
    .lh_title {
      color: #fff;
    }
    .back_icon {
      position: absolute;
      left: 1rem;
      top: 50%;
      transform: translateY(-50%);
      font-size: 2rem;
      cursor: pointer;
    }
}
</style>
